import { gql } from "@apollo/client";

export const getAllRegisteredDogsQuery = gql`
  query GetAllRegisteredDogs(
    $pageNumber: Int!
    $pageSize: Int!
    $search: String
  ) {
    getAllRegisteredDogs(
      pageNumber: $pageNumber
      pageSize: $pageSize
      search: $search
    ) {
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
      data {
        id
        call_name
        registration_name
        breed
        breed_mix
        gender
        authId
        owner_name
        dogImage
        rescue
        date_of_birth
        titleDate
        title
        qs
        dogLegs
        status
        dog_id
      }
    }
  }
`;

export const deleteDogProfileMutation = gql`
  mutation DeleteRegisteredDogs($id: Int!) {
    deleteRegisteredDogs(id: $id) {
      message
    }
  }
`;

export const updateDogProfileMutation = gql`
  mutation UpdateRegisteredDog($id: Int!, $data: UpdateDogByAdminInput!) {
    updateRegisteredDog(id: $id, data: $data) {
      message
    }
  }
`;

export const updateRegisteredDogStatusMutation = gql`
  mutation updateRegisteredDogStatus($id: Int!, $status: String!) {
    updateRegisteredDogStatus(id: $id, status: $status) {
      message
    }
  }
`;

export const addManualDrawMutation = gql`
  mutation AddManualDraw(
    $authId: String!,
    $dogId: Int!,
    $division: String!,
    $elements: String!,
    $searchId: Int,
    $trialCalendarId: Int!
  ) {
    addManualDraw(
      authId: $authId,
      data: {
        dogId: $dogId,
        division: $division,
        elements: $elements,
        searchId: $searchId,
        trialCalendarId: $trialCalendarId
      }
    ) {
      id
      dog
      division
      elements
      trialCalendarId
      authId
      memberName
      email
      address
      phoneNumber
      emergencyContactName
      emergencyContactNumber
    }
  }
`;

export const getDogTrialListByTrialCalendar = gql`
  query GetDogTrialListByTrialCalendar($trialCalendarId: Int!) {
      getDogTrialListByTrialCalendar(
          pageNumber: 1
          pageSize: 1000
          trialCalendarId: $trialCalendarId
      ) {
          pageNumber
          pageSize
          totalDocs
          totalPages
          totalCount
          message
          data {
              id
              dogId
              dog
              breed
              division
              authId
              handler
              memberName
              email
              address
              phoneNumber
              emergencyContactName
              emergencyContactNumber
          }
      }
  }
`;